module.exports = __webpack_public_path__ + "img/ar.9d73a27c.gif";